import { render, staticRenderFns } from "./mail-list-item.vue?vue&type=template&id=96df0d84&scoped=true"
import script from "./mail-list-item.vue?vue&type=script&lang=js"
export * from "./mail-list-item.vue?vue&type=script&lang=js"
import style0 from "./mail-list-item.vue?vue&type=style&index=0&id=96df0d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96df0d84",
  null
  
)

export default component.exports